import { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { selectUser } from "./../utils/redux/userSlice";
import MachineStatus from '../components/MachineStatusComponent/MachineStatus.component';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Spinner } from "react-bootstrap";
import { Instalation } from '../utils/models/Instalation';
import { IOutletContext } from '../utils/interfaces/IOutletContext';
import { getCompanyInstalations } from '../utils/services/company.service';
import { getAllDataByDates, getLastData } from '../utils/services/data.service';
import { MachineData } from '../utils/models/MachineData';
import { DashboardTypes, MachineConected } from 'aw-consts';
import { getLast7days, getTodayDate } from 'aw-date-functions';
import { AWGrid, TableData } from 'aw-grid';
import CharD3, { charData } from '../components/CharProductionComponent/charD3.component';
import { formatNumberWithLeadingZeros, getRandomNumber } from 'aw-generic-functions';
import { format } from 'date-fns';
import { IPosition, MapComponent } from 'aw-map';
import { useTheme } from '../utils/contexts/ThemeContext';
import { Machine } from '../utils/models/Machine';
import MachinesDashboardTable from '../components/MachinesDashboardTable/MachineDashboardTable.component';
import { UserButtonsLine } from 'aw-user-buttons-line';
import { ColumnFiltersState } from '@tanstack/react-table';
import { SearchPanel } from 'aw-search-panel';

const DashboardPage = () => {

    const user = useSelector(selectUser)
    const [instalations, setInstalations] = useState<Instalation[]>([])
    const [data, setData] = useState<MachineData>(new MachineData())
    const [mapPoints, setMapPoints] = useState<IPosition[]>([])
    const [iniDate, setIniDate] = useState(getLast7days())
    const [finDate, setFinDate] = useState(getTodayDate())
    const [loadingData, setLoadingData] = useState(true)
    const [machines, setMachines] = useState<Machine[]>([]);
    const [manual, setManual] = useState(false);
    const { t } = useTranslation();
    const theme = useTheme()
    const getAllMachinesAux = () => {
        const allMachines: Machine[] = instalations.flatMap((inst) =>
            (inst.machines ?? []).map((machine) => ({
                ...machine,
                instalation: inst
            }))
        )

        setMachines(allMachines)
    }

    useEffect(() => {
        getAllMachinesAux();

    }, [instalations]);

    const tableHeaders = [t('Date'), t('Machine'), t('Installation'), t('Operation')]
    const tableBody: TableData[] = [
        { item: [1, format(new Date().setHours(new Date().getHours() - 1), 'dd/MM/yyyy HH:mm'), 'Equipo 1', 'Awayter', 'Product 1'], active: true },
        { item: [2, format(new Date().setHours(new Date().getHours() - 2), 'dd/MM/yyyy HH:mm'), 'Equipo 3', 'Jaén 232', 'Product 2'], active: true },
        { item: [3, format(new Date().setHours(new Date().getHours() - 3), 'dd/MM/yyyy HH:mm'), 'Equipo 5', 'Lleida 261', 'Product 3'], active: true },
        { item: [4, format(new Date().setHours(new Date().getHours() - 4), 'dd/MM/yyyy HH:mm'), 'Equipo 3', 'Salamanca 762', 'Product 4'], active: true },
        { item: [5, format(new Date().setHours(new Date().getHours() - 5), 'dd/MM/yyyy HH:mm'), 'Equipo 2', 'Lisboa 596', 'Product 5'], active: true },
        { item: [6, format(new Date().setHours(new Date().getHours() - 6), 'dd/MM/yyyy HH:mm'), 'Equipo 7', 'Budapest 854', 'Product 6'], active: true },
        { item: [7, format(new Date().setHours(new Date().getHours() - 7), 'dd/MM/yyyy HH:mm'), 'Equipo 8', 'Berlín 845', 'Product 7'], active: true },
        { item: [8, format(new Date().setHours(new Date().getHours() - 8), 'dd/MM/yyyy HH:mm'), 'Equipo 6', 'Roma 426', 'Product 8'], active: true },
        { item: [9, format(new Date().setHours(new Date().getHours() - 9), 'dd/MM/yyyy HH:mm'), 'Equipo 5', 'Awayter', 'Product 9'], active: true }]

    const getCharData = (): charData[] => {
        const charData: charData[] = []
        const now = new Date()
        now.setDate(now.getDate() - 6)
        for (let i = 0; i < 7; i++) {
            charData.push({ date: `${now.getDate()}/${now.getMonth() + 1}`, numItems: getRandomNumber(0, 100) })
            now.setDate(now.getDate() + 1)
        }

        return charData
    }

    const context: IOutletContext = useOutletContext();

    const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 1000);

    useEffect(() => {
        const handleResize = () => {
            setIsWideScreen(window.innerWidth > 1000);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        context.setState(t('Dashboard'))
    })

    useEffect(() => {
        if (loadingData) {
            getLastData(user.token, user.company.idcompany, DashboardTypes.Company)
                .then((md: MachineData) => setData(md))
                .catch((e) => console.error('Error getLastData', e))
                .finally(() => {
                    setTimeout(() => {
                        setLoadingData(false)
                    }, 250)
                })
        }

    }, [loadingData])

    useEffect(() => {
        loadData()
        const interval = setInterval(() => {
            loadData()
        }, 300000) //300000 -> 5min   30000 -> 30s

        return (() => {
            clearInterval(interval)
        })
    }, [])

    const reloadButtonClick = () => {
        setLoadingData(true)
        setTimeout(() => setLoadingData(false), 500)
    }

    const loadData = () => {
        setLoadingData(true)
        getCompanyInstalations(user.token, user.company.idcompany)
            .then((c: Instalation[]) => {
                setInstalations(c)
                if (c && c.length > 0) {
                    const points: IPosition[] = []
                    const colors: string[] = ['#7E7E7E', '#FF0000', '#008000']
                    const maxErrorInstallations = 2;
                    let redCount = 0;
                    c.forEach((i: Instalation) => {
                        let colorIndex = i.idinstalation % colors.length;
                        if (colorIndex === 1) {
                            if (redCount < maxErrorInstallations) {
                                redCount += 1
                            } else {
                                colorIndex = 2
                            }
                        }
                        const priority = colorIndex === 1 ? 1 : (colorIndex === 2 ? 2 : 3); // Vermell = 1, Verd = 2, Gris = 3
                        points.push({
                            id: i.idinstalation,
                            lat: i.lat,
                            lng: i.lng,
                            name: i.name,
                            iconColor: colors[colorIndex],
                            priority: priority,
                            letter: '1'
                        })
                    })
                    setMapPoints(points)
                }
            })
            .catch((e) => {
                console.error('Error getCompanyInstalations', e)
            })
    }

    const onChangeDates = (e: any) => {
        if (e.target.name === "iniDate") {
            setIniDate(e.target.value)
        } else if (e.target.name === "finDate") {
            setFinDate(e.target.value)
        }
    }


    const [filters, setFilters] = useState<ColumnFiltersState>([])
    const predefinedFilters = [
        {
            value: 1,
            label: t('ConnectedMachines'),
            filterConditions: [{ id: "state", value: [t("Connected")] }]
        },
        {
            value: 2,
            label: t("Alarms"),
            filterConditions: [
                { id: "state", value: [t("Alarms")] },
            ]
        }
    ]
    const [selectedPredefinedFilters, setSelectedPredefinedFilters] = useState<(string | number)[]>([]);

    const [globalSearch, setGlobalSearch] = useState<string>('')

    useEffect(() => {
        setFilters((prevFilters) => {
            let mergedFilters = [...prevFilters];

            const predefinedIds = predefinedFilters.flatMap(pf => pf.filterConditions.map(fc => fc.id));
            mergedFilters = mergedFilters.filter(f => !predefinedIds.includes(f.id as string));

            selectedPredefinedFilters.forEach((selected) => {
                const predefined = predefinedFilters.find(pf => pf.value === selected);
                if (predefined) {
                    predefined.filterConditions.forEach(cond => {
                        const existing = mergedFilters.find(f => f.id === cond.id);
                        if (existing) {
                            existing.value = Array.from(new Set([...(existing.value as any[]), ...cond.value]));
                        } else {
                            mergedFilters.push({ id: cond.id, value: cond.value });
                        }
                    });
                }
            });

            return mergedFilters;
        });
    }, [selectedPredefinedFilters]);


    return (
        <>
            <div className='row border-0 mx-2' style={{ maxWidth: "100%" }}>
                <div className='col-12 col-md-12 p-1'>
                    <UserButtonsLine
                        downloardData={() => null}
                        role={user.role}
                        connected={MachineConected.Conected}
                        defaultIni={iniDate}
                        defaultFin={finDate}
                        onChangeDates={onChangeDates}
                        onChangeSelect={() => {
                            return false
                        }}
                        onClickReload={reloadButtonClick}
                        DashboardType={DashboardTypes.Company}
                        changeView={() => null}
                        classNameSecondary='btn-Custom btn-IDGrey'
                        classNameSuccess='btn-Custom btn-IDGreen'
                        containerColor='var(--background-secondary)'
                        dark={theme.theme === "dark" ? true : false}
                        downloadButton={false}
                    />
                </div>
            </div>
            <div className='row border-0 ms-2 me-2' style={{ maxWidth: "100%" }}>
                <div className='col-12 col-sm-4 px-1 mt-1 '>
                    <MachineStatus updLastConnection={() => null} id={user.company.idcompany} token={user.token} refresh={loadingData} title={t("Status")} dashboardType={DashboardTypes.Company} user={user} iniDate={iniDate} finDate={finDate} />
                </div>
                <div className='col-12 col-sm-8 col-md mb-1 mb-sm-0 px-1 mt-1'>
                    <div className='p-2 rounded-1' style={{ backgroundColor: "var(--background-secondary)", height: "500px", width: "100%", boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)" }}>
                        {loadingData ? (
                            <div className='text-center pt-5'>
                                <Spinner animation='border' variant='success' />
                            </div>
                        ) : (
                            <MapComponent
                                url={"userInstalations"}
                                allPositions={mapPoints}
                                enable={true}
                                position={{ lat: 40.4165, lng: -3.70256 }}
                                setPosition={() => {
                                    return false
                                }}
                                showAllPositions={true}
                                iconSize={30}
                                darkMode={theme.theme === "dark" ? true : false}
                            />
                        )}
                    </div>
                </div>
            </div>
            <div className='row border-0 ms-2 me-2' style={{ maxWidth: "100%" }}>
                <div className='col-12 col-md-4 px-1 mt-2'>
                    <AWGrid loading={loadingData} noDataText={t("NoData")} onDeleteClick={() => null} onEditClick={() => null} tableData={tableBody} tableHeaders={tableHeaders} spinnerColor='var(--accent-color)' bgColor='var(--background-secondary)' textColor='var(--text-primary)' title={t("Operations")} manage={false} gridStyle='gridsStyle' />
                </div>
                {/* <div className='col-12 col-md-1 mt-1 p-1'>
                    <KPIs refresh={loadingData} token={user.token} role={user.role} idmachine={1} title={t('KPI')} data={data.quality || 0} color={1} units='%' />
                </div> */}
                <div className='col-12 col-md-8 mt-1 p-1'>
                    <CharD3 dataChar={getCharData()} loading={loadingData} capture={false} title={t("OperationsForDay")} setPNGChar={() => null} />
                </div>
            </div>

            <div className='row border-0 mx-2' style={{ maxWidth: "100%" }}>
                <div className='col-12 col-md-12 p-1' >
                    <div style={{ backgroundColor: "var(--background-secondary)", borderRadius: 'var(--bs-border-radius)' }}>
                        <div className='p-2 d-flex col justify-content-between' >
                            <div className='ms-auto'>
                                <SearchPanel
                                    searchPlaceholder={t('Search')}
                                    searchAction={(query) => setGlobalSearch(query)}
                                    options={predefinedFilters}
                                    value={selectedPredefinedFilters}
                                    onChange={setSelectedPredefinedFilters}
                                />
                            </div>

                        </div>
                        <div>
                            <MachinesDashboardTable machines={machines} manual={manual} instalations={instalations} mapPoints={mapPoints} globalSearch={globalSearch} setGlobalSearch={setGlobalSearch} filtres={filters} setFilters={setFilters} />
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default DashboardPage